import { useNavigate } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  TableHead,
  Box,
} from '@mui/material';

import { Account } from '../../../services/requests/contas/types';

import { TableContainer, TableTitle, TitleBox, TitleBoxStatus } from './styles';

import { InfoCard } from '../../../components/InfoCard';

import {
  getNumberOfEnterprises,
  getNumberOfUsers,
} from '../../../utils/nameHelpers';

interface ListagemContasProps {
  listagemContas: Account[];
  pageAccount: number;
  sizeAccount: number;
  countAccounts: number | undefined;
  setPageAccount: (type: number) => void;
  setSizeAccount: (type: number) => void;
}

export const ListagemContas = ({
  listagemContas,
  pageAccount,
  sizeAccount,
  countAccounts,
  setPageAccount,
  setSizeAccount,
}: ListagemContasProps) => {
  const navigate = useNavigate();

  const handleChangePage = (event: unknown, newPage: number) => {
    setPageAccount(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSizeAccount(+event.target.value);
    setPageAccount(0);
  };

  const defaultLabelDisplayedRows = ({ from, to, count }: any) => {
    return `${from}–${to} de ${count !== -1 ? count : `mais de ${to}`}`;
  };

  return (
    <>
      <TableContainer>
        {listagemContas?.length > 0 ? (
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
            <TableHead
              sx={{
                color: '#000000',
                fontWeight: '400',
                fontSize: '20px',
                margin: '20px 0 15px 24px',
                display: 'table-caption',
              }}
            >
              Contas
            </TableHead>
            <TableHead>
              <TableRow sx={{ width: 'fit-content' }}>
                <TableCell
                  align="left"
                  sx={{
                    alignSelf: 'center',
                    height: '48px',
                    padding: '10px 10px 10px 0px',
                    paddingLeft: '20px',
                  }}
                >
                  <TableTitle>ID CONTA</TableTitle>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    alignSelf: 'center',
                    height: '48px',
                    padding: '10px 10px 10px 0px',
                  }}
                >
                  <TableTitle>CONTA</TableTitle>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    alignSelf: 'center',
                    height: '48px',
                    padding: '10px 10px 10px 0px',
                  }}
                >
                  <TableTitle>EMPRESAS</TableTitle>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    alignSelf: 'center',
                    height: '48px',
                    padding: '10px 10px 10px 0px',
                  }}
                >
                  <TableTitle>USUÁRIOS</TableTitle>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    alignSelf: 'center',
                    height: '48px',
                    padding: '10px 10px 10px 0px',
                    width: '200px',
                  }}
                >
                  <TableTitle>STATUS</TableTitle>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listagemContas?.map((row, index) => {
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={row?.id}
                    onClick={() => navigate(`detalhes-conta/${row?.id}`)}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell
                      id={labelId}
                      scope="row"
                      padding="normal"
                      align="left"
                      sx={{
                        height: '50px',
                        padding: '0',
                        paddingLeft: '20px',
                      }}
                    >
                      <TitleBox>{row?.id?.slice(0, 8)}</TitleBox>
                    </TableCell>

                    <TableCell
                      scope="row"
                      align="left"
                      sx={{
                        height: '50px',
                        padding: '0',
                        maxWidth: '20vw',
                      }}
                    >
                      <Box width="100%">
                        <TitleBox>{row?.name}</TitleBox>
                      </Box>
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        height: '50px',
                        padding: '0',
                      }}
                    >
                      <TitleBox>
                        {getNumberOfEnterprises(row?.records as number)}
                      </TitleBox>
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        height: '50px',
                        padding: '0',
                      }}
                    >
                      <TitleBox>
                        {getNumberOfUsers(row?.total as number)}
                      </TitleBox>
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        height: '50px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <TitleBoxStatus status={row?.status}>
                        {row?.status ? 'Conta ativa' : 'Conta desativada'}
                      </TitleBoxStatus>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <Box display="flex" justifyContent="center" minHeight="50vh">
            <InfoCard title="Nenhuma conta encontrada!" type="info" />
          </Box>
        )}

        {listagemContas?.length > 0 && (
          <TablePagination
            backIconButtonProps={{ disabled: pageAccount === 0 }}
            nextIconButtonProps={{
              disabled:
                (sizeAccount === 5 && listagemContas?.length < 5) ||
                (sizeAccount === 10 && listagemContas?.length < 10) ||
                (sizeAccount === 25 && listagemContas?.length < 25),
            }}
            rowsPerPageOptions={[5, 10, 25]}
            labelRowsPerPage="Linhas por página"
            component="div"
            count={countAccounts as number}
            rowsPerPage={sizeAccount}
            page={pageAccount}
            labelDisplayedRows={defaultLabelDisplayedRows}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </TableContainer>
    </>
  );
};
